class socketConfig {
  static JOIN_SESSION = 'joinSession';
  static PILOT_SESSION = 'pilotSession';
  static PILOT_SESSION_LIVE = 'pilotSessionLive';
 }

module.exports = socketConfig;